<template>
    <div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button class="qinang-button-margin" type="primary" icon="export"
                    @click="addVisible = true">领用</a-button>
                <a-button class="qinang-button-margin" type="danger" icon="delete" @click="tableDelete">删除</a-button>
                <!-- <a-button class="qinang-button-margin" type="danger" icon="rollback" @click="tableReturn">退回</a-button> -->
                <a-button icon="sync" @click="apiPfoutDrawQueryList">刷新</a-button>
            </div>
        </div>

        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="领用记录查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">服务商：</div>
                        <a-select v-model="query.facilitatorId" @change="facilitatorChange">
                            <a-select-option v-for="(item, index) in facilitatorList" :key="index"
                                :value="item.facilitatorId">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">仓库名称：</div>
                        <a-select v-model="query.pflibraryId">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-for="(item, index) in pflibraryList" :key="index"
                                :value="item.pflibraryId">{{ item.pflibraryName }}</a-select-option>
                        </a-select>
                    </div>
					  <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">领取人：</div>
                        <a-select v-model="query.optionStaffId">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-for="(item, index) in staffList" :key="index"
                                :value="item.staffId">{{ item.staffName }}</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
                    <a-button type="primary" icon="search" @click="apiPfoutDrawQueryList">查询</a-button>
                    <a-button icon="redo" @click="resetting" style="margin-left: 14px;">重置</a-button>
                </div>

            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card">
            <a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData"
                row-key="pfoutDrawId" :loading="tableLoading" :pagination="false">
                <span slot="listingPrice" slot-scope="listingPrice">
                    {{ listingPrice.listingPrice / 100 }}
                </span>
                <span slot="startSerial" slot-scope="startSerial">
                    {{ startSerial.prefixCharacter }}{{ startSerial.startSerial }}{{ startSerial.suffixCharacter }}
                </span>
                <span slot="endSerial" slot-scope="endSerial">
                    {{ endSerial.prefixCharacter }}{{ endSerial.endSerial }}{{ endSerial.suffixCharacter }}
                </span>
                <span slot="staffName" slot-scope="staffName">
                    {{staffList.find(item => item.staffId === staffName.staffId)?.staffName || '未指定'}}
                </span>
                <span slot="createTime" slot-scope="createTime">
                    {{ qaUtil.timeFormat(createTime.createTime) }}
                </span>
                <span slot="operator" slot-scope="operator">
                    <a-button type="link" @click="drawDetails(operator)">详情</a-button>
                </span>
            </a-table>
            <a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total"
                :default-page-size="query.size" show-size-changer show-quick-jumper size="small"
                :page-size-options="['10', '20', '50']" :show-total="total => `共 ${total} 条记录`" @change="pageChange"
                @showSizeChange="showSizeChange" />
        </div>

        <!-- 领用弹窗 -->
        <a-modal class="qa-modal" title="领用" width="100%" :visible="addVisible" @cancel="addHandleCancel" :footer="null"
            :maskClosable="false" :keyboard="false">
            <div style="width: 100%;background-color: #fff;">
                <a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 14 }" :rules="addRules">
                    <div class="qa-table-item-3">
                        <a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
                            <a-select v-model="addForm.facilitatorId" placeholder="请选择" @change="facilitatorChangeAdd">
                                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId"
                                    :key="index">{{ item.facilitatorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item label="仓库" has-feedback prop="pflibraryId">
                            <a-select v-model="addForm.pflibraryId" placeholder="请选择" @change="pflibraryChangeAdd">
                                <a-select-option v-for="(item, index) in pflibraryList2" :value="item.pflibraryId"
                                    :key="index">{{ item.pflibraryName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                      
						 <a-form-model-item label="领取人" has-feedback prop="staffId">
                            <a-select v-model="addForm.staffId" placeholder="请选择">
                                <a-select-option v-for="(item, index) in staffList" :value="item.staffId"
                                    :key="index">{{ item.staffName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </div>
                    <div class="qa-table-item-2">
                         <a-form-model-item label="入库批次" has-feedback prop="parentId">
                            <a-select v-model="addForm.parentId" placeholder="请选择" @change="pfoutChangeAdd">
                                <a-select-option v-for="(item, index) in pfoutList2" :value="item.pfoutId"
                                    :key="index">{{ item.prefixCharacter + item.startSerial + item.suffixCharacter }} —— {{ item.prefixCharacter + item.endSerial + item.suffixCharacter }} </a-select-option>
                            </a-select>
                        </a-form-model-item>
                       
                    </div>
					<div class="qa-table-item-3">
                        <a-form-model-item label="起始号码" has-feedback prop="startSerial">
                            <a-input :addon-before="addForm.prefixCharacter" :addon-after="addForm.suffixCharacter" v-model="addForm.startSerial" @change="startSerialChangeAdd"/>
                        </a-form-model-item>
						<a-form-model-item label="截止票号" has-feedback prop="endSerial">
							{{addForm.prefixCharacter}}{{addForm.endSerial}}{{addForm.suffixCharacter}}
						</a-form-model-item>
						 <a-form-model-item label="领用数量" has-feedback prop="total">
                            <a-input v-model="addForm.total" @change="totalChangeAdd"></a-input>
                        </a-form-model-item>
                    </div>
                    <div style="text-align: center;">
                        <a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
                        <a-button type="primary" @click="addHandleOk" :loading="addConfirmLoading">保存</a-button>
                    </div>
                </a-form-model>
            </div>
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            moment,
            selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
            selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
            facilitatorList: [],
            pflibraryList: [],
            pfruleList: [],
            pflibraryList2: [],
            pfoutList2: [],
            pfoutMap: {},
            staffList: [],
            // 搜索+表格-start
            query: {
                page: 1,
                size: 10,
                total: 0,
                pfoutType:"3,4",
                facilitatorId: 0,
                pflibraryId: 0,
                optionStaffId: 0,
                startTime: moment(),
                endTime: moment(),
            },
            tableData: [],
            tableColumns: [
                { title: '仓库名称', dataIndex: 'pflibraryName', key: 'pflibraryName', align: 'center' },
                { title: '门票名称', dataIndex: 'productName', key: 'productName', align: 'center' },
                { title: '价格', key: 'listingPrice', align: 'center', scopedSlots: { customRender: 'listingPrice' } },
                { title: '起始票号', key: 'startSerial', align: 'center', scopedSlots: { customRender: 'startSerial' } },
                { title: '截止票号', key: 'endSerial', align: 'center', scopedSlots: { customRender: 'endSerial' } },
                { title: '领用数量', dataIndex: 'total', key: 'total', align: 'center' },
                { title: '激活数量', dataIndex: 'surplus', key: 'surplus', align: 'center' },
                { title: '退回数量', dataIndex: 'cancelNum', key: 'cancelNum', align: 'center' },
                { title: '领取人', key: 'staffName', align: 'center', scopedSlots: { customRender: 'staffName' } },
                { title: '领用时间', key: 'createTime', align: 'center', scopedSlots: { customRender: 'createTime' } },
                { title: '操作', key: 'operator', align: 'center', scopedSlots: { customRender: 'operator' } },
            ],
            tableLoading: false,
            tableSelectedRows: {},
            tableSelectedRowKeys: [], // 批量选中的key
            //搜索+表格-end
            // 领用弹窗-start
            addVisible: false,
            addConfirmLoading: false,
            addForm: {
                facilitatorId: undefined,
                pflibraryId: undefined,
				parentId: undefined,
                optionStaffId: undefined,
                startSerial: '',
                endSerial: '',
                prefixCharacter: '',
                suffixCharacter: '',
                serialLength: '',
                total: 0,
                surplus: 0,
            },
            addRules: {
                facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
                pflibraryId: [{ required: true, message: '请选择仓库', trigger: 'blur' }],
				parentId: [{ required: true, message: '请选择入库批次', trigger: 'blur' }],
                staffId: [{ required: true, message: '请选择领取人', trigger: 'blur' }],
				startSerial: [{ required: true, message: '请输入起始票号', trigger: 'blur' }],
                total: [
                    { required: true, message: '请输入领用数量', trigger: 'blur' },
                    { pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur' },
                ],
			},
			// 领用弹窗-end
		}
    },
    methods: {
        //获取服务商列表
        async apiFacilitatorList() {
            const {
                data: res
            } = await this.$http.post(this.navigation.apiFacilitatorList, { staffId: window.sessionStorage.getItem('staffId') });
            if (res.code == 200) {
                this.facilitatorList = res.data
                this.query.facilitatorId = res.data[0].facilitatorId
                this.apiPflibraryList(this.query.facilitatorId, 1)
                this.apiPfoutDrawQueryList()
            } else {
                this.$message.error(res.msg)
            }
        },
        //根据服务商选择不同的仓库和门票
        facilitatorChange() {
            this.apiPflibraryList(this.query.facilitatorId, 1)
            this.apiPfroutList(this.query.pflibraryId, 1)
        },
        async apiPflibraryList(facilitatorId, type) {
            const {
                data: res
            } = await this.$http.post(this.navigation.apiPflibraryList, { facilitatorId: facilitatorId });
            if (res.code == 200) {
                if (type == 1) {
                    this.pflibraryList = res.data
                } else {
                    this.pflibraryList2 = res.data
                }
            } else {
                this.$message.error(res.msg)
            }
        },
        async apiPfoutList(pflibraryId, type) {
            const {
                data: res
            } = await this.$http.post(this.navigation.apiPfoutList, { pflibraryId: pflibraryId, pfoutType:2 });
            if (res.code == 200) {
                if (type == 1) {
                    this.pfoutList = res.data
                } else {
                    for (let i = 0; i < res.data.length; i++) {
                        this.pfoutMap['pfout' + res.data[i].pfoutDrawId] = res.data[i]
                    }
                    this.pfoutList2 = res.data
                }
            } else {
                this.$message.error(res.msg)
            }
        },
        async apiStaffList() {
            const {
                data: res
            } = await this.$http.post(this.navigation.apiStaffList, { staffId: window.sessionStorage.getItem('staffId') });
            if (res.code == 200) {
                this.staffList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        //重置
        resetting() {
            this.query = {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: 1,
                pflibraryId: 0,
				pfoutType:"3,4",
                optionStaffId: 0,
                startTime: moment(),
                endTime: moment(),
            }
        },
        //表格开始-搜索
        async apiPfoutDrawQueryList() {
            this.tableLoading = true
            const {
                data: res
            } = await this.$http.post(this.navigation.apiPfoutQueryList, this.query);
            if (res.code == 200) {
                this.tableData = res.data.list
                this.query.page = res.data.pages.page
                this.query.size = res.data.pages.size
                this.query.total = res.data.pages.total
                this.tableLoading = false
                this.tableSelectedRows = {}
                this.tableSelectedRowKeys = []
            } else {
                this.$message.error(res.msg)
                this.tableLoading = false
            }
        },
        pageChange(page, pageSize) {
            this.query.page = page
            this.query.size = pageSize
            this.apiPfoutDrawQueryList()
        },
        showSizeChange(current, size) {
            this.query.page = current
            this.query.size = size
            this.apiPfoutDrawQueryList()
        },
        //领用弹窗
		pfoutChangeAdd(pfoutId) {
			const item = this.pfoutList2.find(p => p.pfoutId == pfoutId)
			this.addForm.prefixCharacter = item.prefixCharacter
			this.addForm.suffixCharacter = item.suffixCharacter
			this.addForm.serialLength = item.serialLength
			this.addForm.conditionNum = item.total - item.surplus - item.cancelNum
			this.addForm.minSerial = parseInt(item.startSerial)
			this.addForm.maxSerial = parseInt(item.endSerial)
            this.addForm.parentId = item.pfoutId
            this.addForm.productId = item.productId
            this.addForm.priceId = item.priceId
            this.addForm.optionStaffId = window.sessionStorage.getItem('staffId')
            this.addForm.startSerial = this.parseStartSerial(item.initialSerial+'', item.serialLength)
            this.addForm.total = 0
		},
        // 服务商选择不同的门票
        facilitatorChangeAdd() {
            this.addForm.pflibraryId = undefined
            this.addForm.parentId = undefined
            this.pfoutList2 = []
            this.addForm.prefixCharacter = ''
            this.addForm.suffixCharacter = ''
            this.apiPflibraryList(this.addForm.facilitatorId, 2)
        },
        // 服务商选择不同的门票后，重新获取门票列表
        pflibraryChangeAdd() {
            this.addForm.parentId = undefined
            this.apiPfoutList(this.addForm.pflibraryId, 2)
        },

        addHandleCancel() {
            this.addVisible = false
        },

        // 领取编号格式化
        parseStartSerial(num ,serialLength){
            let dataLength = num.length
            let startSerial = num
			for(let i=0; i<(serialLength - dataLength); i++) {
				startSerial = '0' + startSerial
			}
			return startSerial.slice(startSerial.length - serialLength) 

        },
        // 领取编号输入框失去焦点时，格式化领取编号
		startSerialChangeAdd() {
            this.addForm.startSerial = this.parseStartSerial(this.addForm.startSerial, this.addForm.serialLength)
			this.totalChangeAdd()
		},
        // 领取数量输入框失去焦点时，验证领取数量
        totalChangeAdd() {
			if(this.addForm.startSerial.length > 0 && this.addForm.total > 0) {
                let serialLength = this.addForm.serialLength
				// 领用数量验证
				if (this.addForm.total > this.addForm.conditionNum) {
					this.$message.warning('领用数量不能大于剩余数量');
					this.addForm.total = this.addForm.conditionNum
				}
                if(parseInt(this.addForm.startSerial) < this.addForm.minSerial) {
					this.$message.warning('领用编号不能小于最小编号');
					this.addForm.startSerial = this.parseStartSerial(this.addForm.minSerial.toString(), serialLength)
                    this.addForm.total = 0
				}
				if(parseInt(this.addForm.startSerial) + parseInt(this.addForm.total-1) > this.addForm.maxSerial) {
					this.$message.warning('领用数量不能大于最大编号');
                    const total = this.addForm.maxSerial - parseInt(this.addForm.startSerial) + 1
					this.addForm.total = total > 0 ? total : 0
				}
				let endSerial = (parseInt(this.addForm.startSerial) + parseInt(this.addForm.total-1)).toString()
				this.addForm.endSerial = this.parseStartSerial(endSerial, serialLength)
			}
        },
        // 领取门票
        async apiPfoutDrawAdd() {
            this.addConfirmLoading = true
			this.addForm.pfoutType = 3
            const {
                data: res
            } = await this.$http.post(this.navigation.apiPfoutCheckOut, this.addForm);
            if (res.code == 200) {
                this.$message.success(res.msg)
                this.$refs.addRuleForm.resetFields();
                this.apiPfoutDrawQueryList()
                this.addConfirmLoading = false
                this.addVisible = false
            } else {
                this.$message.error(res.msg)
                this.addConfirmLoading = false
            }
        },
        // 领取门票-提交
        addHandleOk() {
            this.$refs.addRuleForm.validate(valid => {
                if (valid) {
                    this.apiPfoutDrawAdd()
                } else {
                    return false;
                    this.addConfirmLoading = true
                }
            });

        },
        //领用弹窗事件-结束
        
        drawDetails(item) {
            if (item == undefined) {
                if (!this.tableSelectedRows.pfoutDrawId) {
                    this.$message.warning('请选择要查看的数据');
                    return
                }
                item = this.tableSelectedRows
            }
            let pfoutDetailsMain = []
            pfoutDetailsMain[0] = {'pflibraryName': item.pflibraryName}
            pfoutDetailsMain[1] = {'pfoutCheckOutId': item.pfoutId, 'productName': item.productName, 'pfoutCheckInId': 0}
            window.sessionStorage.setItem("pfoutDetailsMain", JSON.stringify(pfoutDetailsMain))
            this.$router.push('/PfoutDetails')
        },
        tableDelete(){
            if(!this.tableSelectedRows.pfoutId) {
                this.$message.warning('请选择要删除的数据');
                return
            }
            let _this = this
            const item = this.tableSelectedRows
            const content = '票号：' + item.prefixCharacter + item.startSerial + item.suffixCharacter + '至' + item.prefixCharacter + item.endSerial + item.suffixCharacter
            this.$confirm({
                title: '确定要删除当前选中数据吗',
                content: content,
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    _this.apiPfoutDelete(item)
                },
                onCancel() {
                    _this.$message.info('已取消删除');          
                },
            });
        },
        async apiPfoutDelete(item) {
            const {
                data: res
            } = await this.$http.post(this.navigation.apiPfoutDeleteCheckOut+'/'+item.pfoutId);
            if (res.code == 200) {
                this.$message.success(res.msg)
                this.apiPfoutDrawQueryList()
            } else {
                this.$message.error(res.msg)
            }
        },
    },
    computed: {
        rowSelection() {
            let that = this
            // const { selectedRowKeys } = this
            return {
                type: 'radio',
                selectedRowKeys: that.tableSelectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    // console.log(selectedRows);
                    that.tableSelectedRows = selectedRows[0]
                    that.tableSelectedRowKeys = selectedRowKeys
                },
                // getCheckboxProps: record => ({
                // 	props: {
                // 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
                // 		name: record.name,
                // 	},
                // }),
            };
        },
    },
    created() {
        this.apiFacilitatorList()
        this.apiStaffList()
    }
};
</script>

<style scoped></style>